<template>
  <div>
    <div
        v-if="task.parent"
        class="tasks_page__list--item_chip"
        :style="{ 'background-color': 'red' }"
        @click.stop.prevent="goToTaskForm(task.parent)"
    >
      {{ task.parent.short_name.toUpperCase() }}
    </div>
    <v-btn v-if="task.children.length > 0" title="Parent task" class="my-0" color="secondary" small icon>
      <v-icon color="accent">account_tree</v-icon>
    </v-btn>
  </div>
</template>

<script>
  export default {
    name: 'TaskNested',
    props: {
      'task': {
        type: Object,
        default: () => ({ children: [] })
      },
    },
    methods: {
      goToTaskForm(task) {
        this.$router.push({
          name: 'tasks-form',
          params: { project_id: task.project_id, task_id: task.id }
        })
      },
    }
  }
</script>